module.exports = __webpack_public_path__ + "static/media/STWire5.364dd33a.png";